import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=383b3360&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383b3360')) {
      api.createRecord('383b3360', component.options)
    } else {
      api.reload('383b3360', component.options)
    }
    module.hot.accept("./setting.vue?vue&type=template&id=383b3360&", function () {
      api.rerender('383b3360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/setting.vue"
export default component.exports